<template>
  <div class="mainDiv">
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="12">
                <el-form-item label="专业名称：" prop="professionName">
                  <el-col :span="8">
                    <el-input v-model="form.professionName"></el-input>
                  </el-col>
                  <el-col :span="14">
                    <el-button type="primary" size="mini" @click="search"
                      >确定</el-button
                    >
                    <el-button type="primary" size="mini" @click="delAll"
                      >清空</el-button
                    >
                    <el-button size="mini" @click="toggle">关闭</el-button>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="addProfession">添加</el-button>
        <el-button type="primary" @click="toggle">搜索</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      :header-cell-style="{ 'background-color': '#f2f4f6' }"
      style="width: 100%"
    >
      <el-table-column prop="date" label="ID"> </el-table-column>
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column prop="address" label="办学形式"> </el-table-column>
      <el-table-column prop="address" label="培养层次"> </el-table-column>
      <el-table-column prop="address" label="开考状态"> </el-table-column>
      <el-table-column prop="address">
        <template>
          <i class="el-icon-top"></i>
          <i class="el-icon-bottom"></i>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template>
          <span class="table_control" @click="addProfession">编辑</span>
          -
          <span class="table_control">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <AddProfession
      v-if="addProfessionDialog"
      @closeAddProfession="closeAddProfession"
    />
  </div>
</template>

<script>
import AddProfession from './AddProfession.vue'
export default {
  components: {
    AddProfession,
  },
  data() {
    return {
      activeNames: [],
      form: {
        professionName: '',
      },
      tableData: [{}],
      addProfessionDialog: false,
    }
  },
  methods: {
    //搜索的折叠面板
    toggle() {
      this.activeNames.length
        ? (this.activeNames = [])
        : (this.activeNames = ['1'])
    },
    getList() {},
    search() {},
    delAll() {
      this.$refs.form.resetFields()
      this.getList()
    },
    addProfession() {
      this.addProfessionDialog = true
    },
    closeAddProfession() {
      this.addProfessionDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-col {
  font-size: 16px;
}
.tab {
  text-align: left;
  font-size: 0;
  .control {
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    background: #f6f6f6;
  }
}
/deep/.el-collapse-item__header {
  display: none;
}
/deep/.el-collapse-item__wrap {
  border: none;
}
/deep/.el-collapse {
  border: none;
  padding-bottom: 20px;
}
.table_control {
  color: #3695ff;
  cursor: pointer;
}
.table_control:hover {
  color: #66b1ff;
  border-color: transparent;
  background-color: transparent;
}

.el-icon-top,
.el-icon-bottom {
  color: #aaa;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}
.el-icon-bottom {
  margin-left: 4px;
}
.el-icon-top:hover {
  color: #69b6ff;
}
.el-icon-bottom:hover {
  color: #69b6ff;
}
</style>